<template>
  <Button
    variant="circle"
    class="upload-user-file upload-user-file--multiple"
    @click="upload"
  >
    <div
      class="upload-user-file__content upload-content flex"
      :class="{ 'upload-content--loading': loading }"
    >
      <slot />
    </div>
    <input
      ref="file"
      type="file"
      class="upload-content__file"
      multiple
      @change="process"
    >
  </Button>
</template>

<script>
import { Logger } from '@tools/logger/logger';
import { Requests } from '@tools/requests';
import { flashBagError } from '@tools/flashbag';
import { URL_XHR_UPLOAD_USERFILE } from '@tools/routes/routes';
import { trans } from '@elements/translation';
import Button from '@components/Button.vue';

export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Button,
  },
  emits: [ 'input', 'loading', 'done' ],
  data() {
    return {
      loading: false,
      fileSizeLimit: 20, // max file size on client-side validation, cannot exceed 50mB
    };
  },
  methods: {
    upload() {
      if (this.loading) {
        return;
      }
      this.$refs.file.click();
    },
    async process() {
      if (this.loading) {
        return;
      }
      const input = this.$refs.file;
      const filesToUpload = [];
      for (let i = 0; i < input.files.length; i++) {
        const file = input.files[i];
        if (file) {
          if (!this.checkSize(file)) {
            this.$refs.file.value = '';
            flashBagError(trans('upload.size_exceeded', { max: this.fileSizeLimit }));
            return;
          }
          filesToUpload.push(file);
        }
      }
      if (filesToUpload.length === 0) {
        return;
      }
      this.loading = true;
      this.$emit('loading');
      const promises = [];
      for (let i = 0; i < filesToUpload.length; i++) {
        promises.push(this.uploadFile(filesToUpload[i]));
      }
      const newUuids = await Promise.all(promises);
      this.$refs.file.value = '';
      this.loading = false;
      this.$emit('input', newUuids);
      this.$emit('done');
    },
    checkSize(file) {
      const fileSizeMb = (file.size / (1024 * 1024));
      return fileSizeMb < this.fileSizeLimit;
    },
    uploadFile(file) {
      return new Promise((resolve) => {
        const formData = new FormData();
        formData.append('file', file);
        Requests.post(URL_XHR_UPLOAD_USERFILE, formData).then((response) => {
          resolve(response.data);
        }).catch((error) => {
          Logger.error(error);
        });
      });
    },
  },
};
</script>
